// Chat.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import ReactMarkdown from 'react-markdown';
import remarkFootnotes from 'remark-footnotes';
import assistants from './Assistants';


const Chat = () => {
  const [messageSent, setMessageSent] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState(null);

  let { threadId: threadIdFromParams } = useParams();
  const [threadId, setThreadId] = useState(threadIdFromParams || null);

  const navigate = useNavigate();


  const handleNewMessageChange = (event) => {
    setNewMessage(event.target.value);
  };

  const handleSendMessage = (message = newMessage) => {
    setIsLoading(true);
    setMessageSent(prevState => !prevState); // Toggle messageSent state

    const createChatUrl = "https://cpdough--ai-ccc-chat-api-new-chat.modal.run";
    const headers = {
      "Content-Type": "application/json",
    };
    const new_conversation = {
      assistant_id: selectedAssistant.assistantId,
      message: message,
      thread_id: threadId,
    };

    // Log the API call
    console.log('Making API call with URL:', createChatUrl);
    console.log('Headers:', headers);
    console.log('Data:', new_conversation);

    axios.post(createChatUrl, new_conversation, { headers })
      .then(response => {
        if (response.data) {
          if (!threadId) {
            setThreadId(response.data.thread_id);
            navigate(`/chat/${response.data.thread_id}`);
          }
          console.log('API Response:', response.data);
        }
        setNewMessage(""); // Clear the chat message
      })
      .catch(error => {
        console.error("Create Chat Failed:", error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (threadId) {
      setIsLoading(true); // Start loading
      const interval = setInterval(() => {
        axios.get("https://cpdough--ai-ccc-chat-api-get-chat.modal.run", {
          params: {
            thread_id: threadId
          }
        })
        .then(response => {
          const status = response.data.run_status.status;
          if (response.data.messages) {
            setResponseMessage(response.data.messages.reverse());

          // Find the assistant message
          const assistantMessage = response.data.messages.find(message => message.role === 'assistant');
          if (assistantMessage) {
            // Find the assistant in the assistants array
            const assistant = assistants.find(assistant => assistant.assistantId === assistantMessage.assistant_id);
            if (assistant) {
              setSelectedAssistant(assistant); // Set the assistant
            }
          }
          }
          
          if (["completed", "expired", "cancelled", "failed"].includes(status)) {
            clearInterval(interval); // Stop polling
            setIsLoading(false); // Stop loading
          }
        })
        .catch(error => {
          console.error("Get Chat Failed:", error);
          setIsLoading(false);
          clearInterval(interval); // Stop polling
        });
      }, 3000); // Poll every 3 seconds
  
      // Clean up the interval on unmount
      return () => {
        clearInterval(interval);
        setIsLoading(false); // Stop loading
      };
    }
  }, [threadId, messageSent]);

  return (
    <div className="p-6 flex flex-col h-full">
      {!selectedAssistant && !isLoading && (
        <>
        <h2 className="text-2xl font-bold text-center mb-4">Select an AI Assistant:</h2>
        <div className="flex flex-wrap justify-center">
          {assistants.map((assistant, index) => (
            <div key={index} className="p-4 m-2 border rounded shadow-lg w-1/3 cursor-pointer flex flex-col items-center justify-center" onClick={() => setSelectedAssistant(assistant)}>
              <img className="w-1/2 h-64 object-cover" src={assistant.assistantLogo} alt={assistant.name} />
              <h2 className="text-xl font-bold mt-2">{assistant.name}</h2>
              <p className="text-gray-700">{assistant.assistantDescription}</p>
            </div>
          ))}
        </div>
        </>
      )}

      {selectedAssistant && (
        <>
        <div className="flex items-center justify-center">
          <img className="w-10 h-10 object-cover rounded-full" src={selectedAssistant.assistantLogo} alt={selectedAssistant.name} />
          <h2 className="text-lg text-center font-bold">{selectedAssistant.name}</h2>
        </div>
      <div className="overflow-auto">
        {responseMessage.slice(0).map((item, index) => (
          <div key={index} className={`mt-4 p-2 rounded mb-2 ${item.role === 'assistant' ? 'bg-green-300 text-black text-left' : 'bg-blue-500 text-white text-right'} max-w-xl ${item.role === 'assistant' ? 'mr-auto mr-0' : 'ml-auto'}`}>
            <p className="font-bold">{item.role === 'assistant' ? selectedAssistant.name : 'User'}</p>
            {item.content.map((content, index) => (
              <ReactMarkdown key={index} remarkPlugins={[remarkFootnotes]}>{content.text.value}</ReactMarkdown>
            ))}
          </div>
        ))}
      </div>
      <div className="mt-4 flex">
        <input type="text" value={newMessage} onChange={handleNewMessageChange} className="border rounded p-2 w-full" onKeyPress={event => {if (event.key === 'Enter') { event.preventDefault(); handleSendMessage(); }}} 
          placeholder={`Ask a question to the ${selectedAssistant ? selectedAssistant.name : 'AI'} assistant...`}
        />
        <button onClick={() => handleSendMessage()} disabled={isLoading} className={`bg-blue-500 text-white rounded p-2 ml-2 flex items-center ${isLoading ? 'opacity-50' : ''}`}>
          {isLoading ? 'Loading...' : <><FontAwesomeIcon icon={faPaperPlane} className="mr-2" />  Send</>}
        </button>
      </div>
      </>
      )}
    </div>
  );
};

export default Chat;